import React from "react";
import { Popover, Button, Grid, Modal } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const { useBreakpoint } = Grid;

/**
 * راهنمای غیرمزاحم — آیکن «؟» کوچک که با کلیک محتوای راهنما را نشان می‌دهد.
 * دسکتاپ: Popover | موبایل: Modal (طبق قانون layout).
 * هیچ فضایی از workspace نمی‌گیرد.
 *
 * props:
 *   title — عنوان راهنما
 *   content — متن/المان راهنما (string یا node)
 *   label — (اختیاری) متن کنار آیکن، پیش‌فرض «راهنما»
 */
export default function HelpPopover({ title = "راهنما", content, label = "راهنما" }) {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const showModal = () => {
    Modal.info({
      title,
      content: <div style={{ direction: "rtl" }}>{content}</div>,
      okText: "متوجه شدم",
      width: 420,
    });
  };

  if (isMobile) {
    return (
      <Button type="text" size="small" icon={<QuestionCircleOutlined />} onClick={showModal}>
        {label}
      </Button>
    );
  }

  return (
    <Popover
      title={title}
      content={<div style={{ direction: "rtl", maxWidth: 320 }}>{content}</div>}
      trigger="click"
      placement="bottomLeft"
    >
      <Button type="text" size="small" icon={<QuestionCircleOutlined />}>
        {label}
      </Button>
    </Popover>
  );
}
